import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import PropTypes from 'prop-types';

import classes from './MedicalTestCard.module.scss';
import { ResultRow } from './ResultRow/ResultRow';
import { FileRow } from './FileRow/FileRow';
import { CardHeader } from './CardHeader/CardHeader';

const MedicalTestCard = ({ testName, results, onDeleteTest, onEditTest }) => {
  const resultsRows = results.map((result) => {
    const { uploadedTestFiles, ...resultInfo } = result;
    return (
      <div key={result.id} className={classes.resultRow}>
        <ResultRow resultInfo={resultInfo} />
        <FileRow uploadedTestFiles={uploadedTestFiles} />
      </div>
    );
  });

  return (
    <Surface className={classes.testBox}>
      <CardHeader
        testName={testName}
        onDeleteTest={onDeleteTest}
        onEditTest={onEditTest}
      />
      <div className={classes.resultBox}>{resultsRows}</div>
    </Surface>
  );
};

MedicalTestCard.propTypes = {
  testName: PropTypes.string,
  results: PropTypes.array,
  onDeleteTest: PropTypes.func,
  onEditTest: PropTypes.func,
};

export { MedicalTestCard };
